import styled from 'styled-components';
import {Button, EMPHASIS} from '@forecast-it/design-system';

interface Props {
	selectedCount: number;
	onAssign: () => void;
	onClear: () => void;
	disabled?: boolean;
}

const Bar = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	border-radius: ${p => p.theme.sys.size.borderradius['3']};
	border: 1px solid #e9d5ff;
	background: #f3e8ff;
	padding: 8px 16px;
	box-shadow: 0 1px 2px rgb(0 0 0 / 0.05);
`;

const CountLabel = styled.span`
	${p => p.theme.sys.font?.subheading?.['2']}
	color: #334155;
`;

export function BulkActionBar({selectedCount, onAssign, onClear, disabled}: Props) {
	return (
		<Bar>
			<CountLabel>{selectedCount} selected</CountLabel>
			<Button emphasis={EMPHASIS.HIGH} onPress={onAssign} disabled={disabled}>
				Assign selected
			</Button>
			<Button emphasis={EMPHASIS.MEDIUM} onPress={onClear}>
				Clear selection
			</Button>
		</Bar>
	);
}
